import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import Title from "../Title/Title";
import "swiper/css";
import "swiper/css/navigation";
import "./ProductSlider.css";

import ProductCard from "./ProductCard";
import image from "../../assets/images/product/prod1.png";

export default function ProductSlider({ title, products }) {

    return (
        <>
            {products && products.length > 0 &&
                <>
                    <Title title={title} />
                    <div className="product-slider-container relative">
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            slidesPerView={4}
                            loop={true}
                            navigation={true}
                            observer={true}
                            autoplay={{ delay: 4000, disableOnInteraction: false }}
                            breakpoints={{
                                320: { slidesPerView: 2, spaceBetween: 8 },
                                640: { slidesPerView: 2, spaceBetween: 10 },
                                1024: { slidesPerView: 3, spaceBetween: 15 },
                                1280: { slidesPerView: 5, spaceBetween: 20 },
                                1480: { slidesPerView: 6, spaceBetween: 25 },
                            }}
                            watchOverflow={true}
                            className="custom-swiper"
                        >
                            {products && products.map((product) => (
                                <SwiperSlide key={product._id}>
                                    <ProductCard product={product} />
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </>
            }
        </>
    );
}